import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { CustomRadioButtonGroupItem } from "../../../../../../CustomRadioButtonGroupItem";
import { useSelectedTheme } from "../../../../../../../../Hooks";
import {
  CheckIcon,
  CloseXIcon,
  FlamefireIcon,
  SnowFlakeIcon,
  ThermometerIcon,
} from "../../../../../../../../assets/icons";
import { useVerticalNav } from "../../../../../../../../Contexts/VerticalNavContext";
import { CustomAutocomplete } from "../../../../../../CustomAutocomplete";

// styles
import useStyles from "./styles";

const MyLeadLeadDetailsFields = ({
  data,
  state,
  selected,
  onStateChangeHandler,
  onSelectedChangeHandler,
  reloadAllCampaignName,
  translate,
}) => {
  const [optionData, setOptionData] = useState({
    leadStatus: [],
    leadRating: [],
  });

  const styles = useStyles();
  const searchTimer = useRef(null);
  const { setAlertBoxContent } = useVerticalNav();

  const {
    theme: { palette },
  } = useSelectedTheme();

  useEffect(() => {
    const formatOptions = (items = []) =>
      items.reduce((acc, { lookupItemId, lookupItemName }) => {
        acc[lookupItemName.toLowerCase()] = {
          id: lookupItemId,
          name: lookupItemName,
        };
        return acc;
      }, {});

    setOptionData({
      leadStatus: formatOptions(data?.leadStatus),
      leadRating: formatOptions(data?.leadRating),
    });
  }, [data]);

  const isReasonSelectDisallowed = (selectedOption) => {
    let isDisallowedOpt =
      selectedOption?.lookupItemName === "Lead Close by Transaction";

    if (isDisallowedOpt)
      setAlertBoxContent({
        display: true,
        variant: "warning",
        title: translate("selecting-this-option-manually-is-not-allowed"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    return isDisallowedOpt;
  };

  return (
    <Box className={styles.wrapperMyLeadLeadDetailsFields}>
      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Lead-status")}*
        </Typography>
        <Box className={styles.containerOptions}>
          <CustomRadioButtonGroupItem
            checked={
              selected?.leadStatus === Number(optionData?.leadStatus?.open?.id)
            }
            onChange={(event) => {
              const leadStatusId = Number(event?.target?.value);
              onSelectedChangeHandler("leadStatus", Number(leadStatusId));
              onStateChangeHandler("leadStatusId", Number(leadStatusId));
              onStateChangeHandler("closedReasonId", null);
              onSelectedChangeHandler("closeLeadResoun", null);
            }}
            label={optionData?.leadStatus?.open?.name}
            icon={
              <CheckIcon
                width="20"
                height="20"
                fill={palette.text.success_primary}
              />
            }
            value={Number(optionData?.leadStatus?.open?.id)}
          />
          <CustomRadioButtonGroupItem
            checked={
              selected?.leadStatus ===
              Number(optionData?.leadStatus?.closed?.id)
            }
            onChange={(event) => {
              const leadStatus = Number(event?.target?.value);
              if (isReasonSelectDisallowed(Number(leadStatus))) return;
              onSelectedChangeHandler("leadStatus", Number(leadStatus));
              onStateChangeHandler("leadStatusId", Number(leadStatus));
              onStateChangeHandler("closedReasonId", null);
              onSelectedChangeHandler("closeLeadResoun", null);
            }}
            label={optionData?.leadStatus?.closed?.name || translate("close")}
            icon={
              <CloseXIcon
                width="20"
                height="20"
                fill={palette.button.destructive_bg}
              />
            }
            value={Number(optionData?.leadStatus?.closed?.id)}
          />
        </Box>
      </Box>
      <Divider />

      {state && state.leadStatusId && state.leadStatusId === 458 && (
        <>
          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("close-Lead-Resson")}*
            </Typography>
            <CustomAutocomplete
              options={data?.closeLeadResoun}
              renderOption={(option) => option.lookupItemName || ""}
              getOptionLabel={(option) => option?.lookupItemName || ""}
              getOptionValue={(option) => option?.lookupItemId || ""}
              onChange={(event, newValue) => {
                if (isReasonSelectDisallowed(newValue)) return;
                onSelectedChangeHandler("closeLeadResoun", newValue);
                onStateChangeHandler(
                  "closedReasonId",
                  newValue && newValue.lookupItemId
                );
              }}
              value={selected?.closeLeadResoun}
            />
          </Box>
          <Divider />
        </>
      )}

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Lead-rating")}*
        </Typography>
        <Box className={styles.containerOptions}>
          <CustomRadioButtonGroupItem
            checked={
              selected?.leadRating === Number(optionData?.leadRating?.cold?.id)
            }
            onChange={(event) => {
              const leadRatingId = Number(event?.target?.value);
              onSelectedChangeHandler("leadRating", Number(leadRatingId));
              onStateChangeHandler("leadRatingId", Number(leadRatingId));
            }}
            label={optionData?.leadRating?.cold?.name || translate("Cold")}
            icon={
              <SnowFlakeIcon
                width="20"
                height="20"
                fill={palette.utility.utility_gray_500}
              />
            }
            value={Number(optionData?.leadRating?.cold?.id)}
          />

          <CustomRadioButtonGroupItem
            checked={
              selected?.leadRating === Number(optionData?.leadRating?.warm?.id)
            }
            onChange={(event) => {
              const leadRatingId = Number(event?.target?.value);
              onSelectedChangeHandler("leadRating", Number(leadRatingId));
              onStateChangeHandler("leadRatingId", Number(leadRatingId));
            }}
            label={optionData?.leadRating?.warm?.name || translate("Warm")}
            icon={
              <ThermometerIcon
                width="20"
                height="20"
                fill={palette.utility.utility_gray_500}
              />
            }
            value={Number(optionData?.leadRating?.warm?.id)}
          />

          <CustomRadioButtonGroupItem
            checked={
              selected?.leadRating === Number(optionData?.leadRating?.hot?.id)
            }
            onChange={(event) => {
              const leadRatingId = Number(event?.target?.value);
              onSelectedChangeHandler("leadRating", Number(leadRatingId));
              onStateChangeHandler("leadRatingId", Number(leadRatingId));
            }}
            label={optionData?.leadRating?.hot?.name || translate("Hot")}
            icon={
              <FlamefireIcon
                width="20"
                height="20"
                fill={palette.utility.utility_gray_500}
              />
            }
            value={Number(optionData?.leadRating?.hot?.id)}
          />
        </Box>
      </Box>
      <Divider />

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Media-details")}*
        </Typography>
        <CustomAutocomplete
          options={data.mediaName}
          renderOption={(option) => option.lookupItemName || ""}
          getOptionLabel={(option) => option?.lookupItemName || ""}
          getOptionValue={(option) => option?.lookupItemId || ""}
          onChange={(event, newValue) => {
            onSelectedChangeHandler(
              "MediaDetail",
              (newValue && newValue) || null
            );
            onStateChangeHandler(
              "mediaDetailId",
              (newValue && newValue.lookupItemId) || null
            );
          }}
          value={selected.MediaDetail}
        />
      </Box>

      <Divider />

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Method-Of-Contact")}*
        </Typography>
        <CustomAutocomplete
          options={data.MediaDetail}
          renderOption={(option) => option.lookupItemName || ""}
          getOptionLabel={(option) => option?.lookupItemName || ""}
          getOptionValue={(option) => option?.lookupItemId || ""}
          onChange={(event, newValue) => {
            onSelectedChangeHandler(
              "mediaName",
              (newValue && newValue) || null
            );
            onStateChangeHandler(
              "MethodOfContact",
              (newValue && newValue.lookupItemId) || null
            );
          }}
          value={selected.mediaName}
        />
      </Box>

      <Divider />

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Campaign-name")}
        </Typography>
        <CustomAutocomplete
          options={data.campaignName}
          renderOption={(option) => option.name || ""}
          getOptionLabel={(option) => option.name || ""}
          getOptionValue={(option) => option.name || ""}
          onChange={(event, newValue) => {
            onSelectedChangeHandler("campaignName", newValue || null);
            onStateChangeHandler(
              "propertyCampaignId",
              (newValue && newValue.propertyCampaignId) || null
            );
          }}
          onInputKeyUp={(e) => {
            const { value } = e.target;
            if (searchTimer.current) clearTimeout(searchTimer.current);
            searchTimer.current = setTimeout(() => {
              reloadAllCampaignName(value);
            }, 700);
          }}
          value={selected.campaignName}
        />
      </Box>
    </Box>
  );
};
export default MyLeadLeadDetailsFields;
